import { render, staticRenderFns } from "./ContentComponent.vue?vue&type=template&id=1a52a51c&"
import script from "./ContentComponent.vue?vue&type=script&lang=js&"
export * from "./ContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./ContentComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports